import { z } from "zod";
import { optionalFilterString } from "@/schemas/filter.schema";

/**
 * Search-param schema shared by the admin & fleet vehicle detail routes.
 *
 * `tab` drives the `UrlTabs` selection; the `usage*` params back the admin-only
 * "Usages" tab filters (date range, driver remoteId). They live on the route so
 * the filtered view is shareable/bookmarkable, per `table-pages.md`.
 *
 * `tab` uses `.catch` (not `.default`): `.default` only fires on `undefined`, so a
 * stale, typoed or externally mangled `?tab=` value threw out of `validateSearch`
 * and replaced the page with the route error boundary.
 */
export const vehicleDetailSearchSchema = z.object({
	tab: z
		.enum([
			"general",
			"telematics",
			"tasks",
			"charging",
			"scheduler",
			"usages",
			"access",
			"damages",
			"damage3d",
			"documents",
			"activityLog",
		])
		.catch("general"),
	usagePeriod: optionalFilterString,
	usageDriver: optionalFilterString,
});

/**
 * Every tab the detail page can show. Type the page's tab list with this: a tab
 * missing from the enum above is otherwise rewritten to `general` by `.catch`,
 * silently, so the tab can never be opened.
 */
export type VehicleDetailTab = z.infer<typeof vehicleDetailSearchSchema>["tab"];
